import { useState, useEffect } from "react";
import { Link, NavLink, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import {
  HiOutlineHome,
  HiOutlineShoppingBag,
  HiOutlineUserCircle,
  HiOutlineUserGroup,
  HiOutlineNewspaper,
  HiOutlineLogin,
  HiOutlineLogout,
} from "react-icons/hi";
import { logo } from "../../../assets";
import ColorChangingIcon from "../../../helpers/ColorChangingIcon/ColorChangingIcon";

const AdminPcMenu = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const token = localStorage.getItem("token");
  const isLogin = !isEmpty(token);

  if (!isLogin) return <Navigate to="/" replace />;

  return (
    <div className="fixed z-10 top-0 pb-3 px-6 w-full lg:flex hidden flex-col justify-between h-screen border-l border-yellow-600 bg-gray-200 transition duration-300 md:w-4/12 lg:ml-0 lg:w-[25%] xl:w-[20%] 2xl:w-[15%]">
      {/* Header Section */}
      <div className="flex flex-col items-center pt-6">
      <div className="flex flex-col items-center mb-6">
          <img
            src={logo}
            width={150}
            className="bg-cover mb-2"
            alt="Website Logo"
          />
          <p className="text-black text-lg font-medium">هو الرزاق</p>
        </div>

        <div className="flex justify-between w-full px-4 mb-8">
          <Link to="/Public/Home">
            <button className="p-2 rounded-full hover:bg-yellow-50 transition">
              <HiOutlineHome size={25} className="text-yellow-600" />
            </button>
          </Link>

        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-grow flex flex-col">
        {/* Navigation Menu */}
        <ul className="space-y-3 tracking-wide text-black font-medium">
          {/* Profile */}
          <li>
            <NavLink
              to="/Admin/Dashboard/Profile"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center space-x-4 bg-yellow-100 rounded-xl cursor-pointer border border-yellow-300"
                  : "relative px-4 py-3 flex items-center space-x-4 rounded-xl hover:bg-yellow-50 cursor-pointer"
              }
            >
              
              <HiOutlineUserCircle size={25} className="ml-2 text-yellow-600"/>
              <span className="-mr-1">پروفایل</span>
            </NavLink>
          </li>

          {/* Users */}
          <li>
            <NavLink
              to="/Admin/Dashboard/Users"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center space-x-4 bg-yellow-100 rounded-xl cursor-pointer border border-yellow-300"
                  : "relative px-4 py-3 flex items-center space-x-4 rounded-xl hover:bg-yellow-50 cursor-pointer"
              }
            >
              
               <HiOutlineUserGroup size={25} className="ml-2 text-yellow-600"/>
              <span className="-mr-1">کاربران</span>
            </NavLink>
          </li>

          {/* Products */}
          <li>
            <NavLink
              to="/Admin/Dashboard/Products"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center space-x-4 bg-yellow-100 rounded-xl cursor-pointer border border-yellow-300"
                  : "relative px-4 py-3 flex items-center space-x-4 rounded-xl hover:bg-yellow-50 cursor-pointer"
              }
            >
            
              <HiOutlineShoppingBag size={25} className="ml-2 text-yellow-600"/>
              <span className="-mr-1">محصولات</span>
            </NavLink>
          </li>

          {/* Requests */}
          <li>
            <NavLink
              to="/Admin/Dashboard/Requests"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center space-x-4 bg-yellow-100 rounded-xl cursor-pointer border border-yellow-300"
                  : "relative px-4 py-3 flex items-center space-x-4 rounded-xl hover:bg-yellow-50 cursor-pointer"
              }
            >
              <HiOutlineLogin size={25} className="ml-2 text-yellow-600"/>
              <span className="-mr-1">درخواست‌های ورود</span>
            </NavLink>
          </li>

          {/* News */}
          <li>
            <NavLink
              to="/Admin/Dashboard/News"
              className={({ isActive }) =>
                isActive
                  ? "relative px-4 py-3 flex items-center space-x-4 bg-yellow-100 rounded-xl cursor-pointer border border-yellow-300"
                  : "relative px-4 py-3 flex items-center space-x-4 rounded-xl hover:bg-yellow-50 cursor-pointer"
              }
            >
              <HiOutlineNewspaper size={25} className="ml-2 text-yellow-600"/>
              <span className="-mr-1">اخبار</span>
            </NavLink>
          </li>
        </ul>

        {/* Spacer to push footer down */}
        <div className="flex-grow"></div>
      </div>

      {/* Footer Section */}
      <div className="px-6 -mx-6 py-4 flex justify-center items-center"></div>
    </div>
  );
};

export default AdminPcMenu;